// components/MobileNavigationAdmin.jsx
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const MobileNavigationAdmin = ({ menuItems }) => {
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <div className="fixed bottom-0 left-0 right-0 bg-white border-t lg:hidden z-40">
            <div className="flex justify-around py-2">
                {menuItems.slice(0, 4).map((item, index) => {
                    const isActive = location.pathname === item.path;
                    return (
                        <button
                            key={index}
                            onClick={() => navigate(item.path)}
                            className="flex flex-col items-center p-2"
                        >
                            {React.cloneElement(item.icon, {
                                className: `w-6 h-6 ${isActive ? 'text-[#96B734]' : 'text-[#437011]'}`
                            })}
                            <span className={`text-xs mt-1 ${isActive ? 'text-[#96B734] font-medium' : 'text-[#437011]'}`}>
                                {item.label}
                            </span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default MobileNavigationAdmin;